import { CheckCircle2, Circle, CircleDot, MinusCircle } from "lucide-react";
import type { FC } from "react";

import { cn } from "@/lib/utils";

export type StepState = "done" | "open" | "current" | "skipped";

/** A checklist step's state as one 16px mark. */
export const StepDot: FC<{ state: StepState; className?: string }> = ({
  state,
  className
}) => {
  const base = cn("size-4 shrink-0", className);
  if (state === "done")
    return <CheckCircle2 className={cn(base, "text-success")} aria-hidden />;
  if (state === "skipped")
    return <MinusCircle className={cn(base, "text-fg-4")} aria-hidden />;
  if (state === "current")
    return <CircleDot className={cn(base, "text-accent")} aria-hidden />;
  return <Circle className={cn(base, "text-fg-4")} aria-hidden />;
};
